module.exports = __webpack_public_path__ + "img/logo-white.79deae3d.png";